export const ceroText = '0'
